import { getYoutubeVideoCover } from "@/utils/youtube";
import BlogContent from "../BlogContent";
import { BLOG_TAGS } from "../BlogTags";

const PODCAST_1: BlogContent = {
    id: 11,
    label: "Tyrimas, kuris pasako viską apie tave",
    description: "Sužinok, kaip tavo genetika gali tapti galingiausiu ginklu prieš ligas ir raktu į ilgaamžiškumą. Šiame epizode sužinosi, ką gali padaryti jau šiandien, kad gyventum ilgiau ir sveikiau",
    descriptionInner: "Sužinok, kaip tavo genetika gali tapti galingiausiu ginklu prieš ligas ir raktu į ilgaamžiškumą. Šiame epizode sužinosi, ką gali padaryti jau šiandien, kad gyventum ilgiau ir sveikiau",
    img_src: getYoutubeVideoCover("JmruGcrWDZw"),
    alt: "Podcastas nr.1",
    tags: [BLOG_TAGS.PODCASTS.label, BLOG_TAGS.GENETICS.label, BLOG_TAGS.EPIGENETICS.label, BLOG_TAGS.SPORTS.label],
    // more_blogs_ids: [1, 2, 3],
    // author: "FOTO: DELFI / KAROLINA GUDŽIŪNIENĖ",
    innerData: [
    {
        id: 1,
        description: [
            "Šiame epizode farmacininkas Jokūbas Malikėnas kalbina du genetikos srities lyderius – Vaidą Dirsę ir Rimvydą Norvilą.",
            "Jie atskleidžia, kaip genomo ir polimorfizmų tyrimai gali numatyti ligų rizikas dar prieš pasireiškiant simptomams, ir kaip gyvensenos genetika tampa galingu įrankiu ilgaamžiškumui.",
            "Sužinosite konkrečius pavyzdžius, kaip šios žinios jau dabar keičia žmonių gyvenimus – nuo ligų prevencijos iki asmeninių sveikatos strategijų, pritaikytų pagal unikalų genetinį kodą."
        ]
    }],
    podcasts: {
        youtube: "JmruGcrWDZw" ,
        spotify: "6TsxWUB1UqlHZeNhwq2Iad?si=a022226b91cd4b33",
        apple: "1000721513524"
    }
}

export default PODCAST_1;